export const NEW_UPIID_REGEX = /^[a-zA-Z0-9]{6}\d{2}[a-zA-Z]\d{4}$/;

// Obsolete - this was used in the view solicitation page to show reopen/midcycle button
// Using isValidUPIID instead to enforce AAC for selection dropdown
export const isUpiidLegacyFormat = (upiid) => !NEW_UPIID_REGEX.test(upiid);

export const isValidUPIID = (uPIID, aacCodes) =>
  aacCodes.some((aac) => uPIID?.startsWith(aac)) && NEW_UPIID_REGEX.test(uPIID);
